import { render, staticRenderFns } from "./CaseEdit.vue?vue&type=template&id=2c4e9ace&scoped=true&"
import script from "./CaseEdit.vue?vue&type=script&lang=js&"
export * from "./CaseEdit.vue?vue&type=script&lang=js&"
import style0 from "./CaseEdit.vue?vue&type=style&index=0&id=2c4e9ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4e9ace",
  null
  
)

export default component.exports